import { render, staticRenderFns } from "./placeofserviceList.vue?vue&type=template&id=07d879d2&"
import script from "./placeofserviceList.vue?vue&type=script&lang=js&"
export * from "./placeofserviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports